import { Button } from '@gazin/ecommerce-ui'
import { useRouter } from 'next/router'
import { makePageUrl } from 'src/util/url'
import { PageLink } from '../navigation'

type PaginationItemProps = {
  page: number
  isCurrent?: boolean
  onNavigate?: (page: number) => void
}

export const PaginationItem = ({
  isCurrent = false,
  page,
  onNavigate,
}: PaginationItemProps) => {
  const route = useRouter()

  if (isCurrent) {
    return (
      <Button
        size="sm"
        fontSize="xs"
        width="4"
        colorScheme="primary"
        disabled
        _disabled={{ bgColor: '#0D71F0', cursor: 'default' }}
        value={page}
      >
        {page}
      </Button>
    )
  }
  return (
    <PageLink
      href={makePageUrl(page, route)}
      page={page}
      onNavigate={onNavigate}
    >
      <Button
        size="sm"
        fontSize="xs"
        width="4"
        bg="white"
        border="1px solid"
        borderColor="#DCDDE3"
        borderRadius=".1875rem"
        color="#646981"
        _hover={{ bg: '#0d6ff0aa', color: 'white' }}
        value={page}
      >
        {page}
      </Button>
    </PageLink>
  )
}
